/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { Box, TextField } from '@material-ui/core';
import { Button, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../../SharedModules/Errors/SuccessMessage';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getChildGridDetailList,
  getGovGridNdcDetaliList,
  getTopGridCalculatedURAData,
  setCalculatedURAHeaderData,
  setCalculatedURAIndex,
} from '../../store/actions';
import BottomGridTable from './BottomTable';
import CalculatedURATable from './CalculatedURATable';
import TopGridTable from './TopGridTable';
import { planTypeList } from '../URASearch';
import Spinner from '../../../../../SharedModules/Spinner/Spinner';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {
  handleQuarterFormate,
  handleScrollToEvent,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const SelectedURA = () => {
  const dispatch = useDispatch();
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [disableBtn, setDisableBtn] = useState(false);

  const calculatedURAHeaderData = useSelector(
    (state) => state.sharedState.URASearchReducer?.calculatedURAHeaderData
  );
  const calculatedURAHeaderDataList = useSelector(
    (state) => state.sharedState.URASearchReducer?.calculatedURAHeaderDataList
  );
  const rebateProgramCode = useSelector(
    (state) => state.sharedState.URASearchReducer?.rebateProgramCode?.data
  );
  const calculatedURAIndex = useSelector(
    (state) => state.sharedState.URASearchReducer?.calculatedURAIndex
  );
  const URASearchFormValues = useSelector(
    (state) => state.sharedState.URASearchReducer?.URASearchFormValues
  );
  useEffect(() => {
    const fetchData = async () => {
      if (calculatedURAHeaderData) {
        setSpinnerLoader(true);
        if (
          calculatedURAHeaderData?.planTypeCd === 'COMM' ||
          calculatedURAHeaderData?.planTypeCd === 'SUPP'
        ) {
          const response = await dispatch(
            getTopGridCalculatedURAData({
              contractSeqNum: calculatedURAHeaderData.contractSeqNum,
              familySeqNum: calculatedURAHeaderData.familySeqNum,
              drugSeqNum: calculatedURAHeaderData.drugSeqNum,
              startQtr: calculatedURAHeaderData.targetQtr,
              endQtr: calculatedURAHeaderData.targetQtr,
            })
          );
          if (response.length) {
            await dispatch(
              getChildGridDetailList({
                rebateProgramCd: calculatedURAHeaderData.rebateProgramCd,
                mfgId: calculatedURAHeaderData.mfgId,
                targetQtr: calculatedURAHeaderData.targetQtr,
                startQtr: calculatedURAHeaderData.targetQtr,
                endQtr: calculatedURAHeaderData.targetQtr,
                drugSeqNum: calculatedURAHeaderData.drugSeqNum,
                contractFamilySeqNum: response?.[0]?.familySeqNum,
              })
            );
          }
        }
        if (
          calculatedURAHeaderData?.planTypeCd === 'FD' ||
          calculatedURAHeaderData?.planTypeCd === 'ST'
        ) {
          await dispatch(
            getGovGridNdcDetaliList({
              selection:
                URASearchFormValues?.selectOneOption === 'NDC'
                  ? 'ndc'
                  : URASearchFormValues?.selectOneOption === 'Manufacturer'
                  ? 'mfg'
                  : '',
              planType:
                calculatedURAHeaderData?.planTypeCd === 'FD' ||
                calculatedURAHeaderData?.planTypeCd === 'ST'
                  ? 'G'
                  : 'C',
              rebateProgramCd: calculatedURAHeaderData.rebateProgramCd,
              drugSeqNum: calculatedURAHeaderData.drugSeqNum,
              contractSeqNum: calculatedURAHeaderData.contractSeqNum,
              qtrType:
                URASearchFormValues.quarters === 'all'
                  ? 'ALL'
                  : URASearchFormValues.quarters === 'target'
                  ? 'TARGET'
                  : 'CALC',
              quarter: URASearchFormValues.quarter || null,
            })
          );
        }
        setSpinnerLoader(false);
      }
    };
    fetchData();
  }, [calculatedURAHeaderData]);

  useEffect(() => {
    setTotalCount(calculatedURAHeaderDataList.length);
  }, [calculatedURAHeaderDataList]);
  useEffect(() => {
    handleScrollToEvent();
  }, []);
  const clickPrevious = () => {
    dispatch(setCalculatedURAIndex(calculatedURAIndex - 1));
    dispatch(
      setCalculatedURAHeaderData(
        calculatedURAHeaderDataList[calculatedURAIndex - 1]
      )
    );
  };

  const clickNextRow = () => {
    dispatch(setCalculatedURAIndex(calculatedURAIndex + 1));
    dispatch(
      setCalculatedURAHeaderData(
        calculatedURAHeaderDataList[calculatedURAIndex + 1]
      )
    );
  };

  const handlePage = (e) => {
    dispatch(
      setCalculatedURAIndex(
        Math.min(Math.max(Number(e.target.value) - 1, 0), totalCount - 1)
      )
    );
  };

  const onBlurPage = () => {
    dispatch(
      setCalculatedURAHeaderData(
        calculatedURAHeaderDataList[calculatedURAIndex]
      )
    );
  };

  return (
    <div className='tBillPanel custom-check'>
      <div className='panel tBillPanel-space devider-line pb-0'>
        {spinnerLoader && <Spinner load={spinnerLoader} />}
        <CustomSeparator
          parent1='Display'
          parent2='View Calculated URA Detail'
        />
        {!fullScreenView && (
          <>
            <DisplayErrorMessages errorMessages={errorMessages} />
            <DisplaySuccessMessages successMessages={successMessages} />
            <Box className='alone-pagination mb-2'>
              <Box>
                <Button
                  title='Previous '
                  className='btns rotate-left'
                  data-testid='uc-paginate-arrow-left'
                  type='button'
                  onClick={clickPrevious}
                  disabled={
                    calculatedURAIndex > 0 && !disableBtn ? false : true
                  }
                >
                  <SVGComponent iconName='Icon-arrow' />
                  <span className='hide-elm'>Previous</span>
                </Button>
              </Box>
              <Box>
                <label className='m-0' htmlFor='paginate-count'>
                  <TextField
                    id='paginate-count'
                    data-testid='uc-input-paginate'
                    variant='outlined'
                    className='searchInput input-count'
                    size='small'
                    value={calculatedURAIndex + 1}
                    onChange={(e) => handlePage(e)}
                    onBlur={onBlurPage}
                  />
                </label>
              </Box>
              <Box className='btns'>Of {totalCount}</Box>
              <Box>
                <Button
                  title='Next '
                  className='btns rotate-right ml-0'
                  data-testid='uc-paginate-arrow-right'
                  type='button'
                  onClick={clickNextRow}
                  disabled={
                    calculatedURAIndex + 1 !== totalCount && !disableBtn
                      ? false
                      : true
                  }
                >
                  <SVGComponent iconName='Icon-arrow' />
                  <span className='hide-elm'>Next</span>
                </Button>
              </Box>
            </Box>
            <div className='panel mb-3'>
              <fieldset className='custom-fieldset'>
                <div className='form-wrapper p-0 mt-2'>
                  <div className='mui-custom-form input-md field-xl'>
                    <div className='sub-radio no-margin'>
                      <div className='row'>
                        <div className='col-4 d-flex'>
                          <TextField
                            className='mandate-fields mr-2'
                            id='plan_type'
                            label={'Plan Type'}
                            disabled={true}
                            value={calculatedURAHeaderData?.planTypeCd}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            helperText={''}
                          />
                          {/* <label
                            className='m-0 hide-elm'
                            htmlFor='plan_type_code'
                          >
                            <span>label</span>{' '}
                          </label> */}
                          <TextField
                            className='mandate-fields frr-display-hidden-label'
                            label={'Plan Type'}
                            id='plan_type_code1'
                            disabled={true}
                            value={String(
                              planTypeList.find(
                                (item) =>
                                  item.value ===
                                  calculatedURAHeaderData?.planTypeCd
                              )?.label ?? ''
                            ).toUpperCase()}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              id: 'plan_type_code1',
                            }}
                            helperText={''}
                          />
                        </div>

                        <div className='col-4 d-flex'>
                          <TextField
                            className='mandate-fields mr-2'
                            id='rebate_program_code'
                            label={'Rebate Program Code'}
                            disabled={true}
                            value={calculatedURAHeaderData?.rebateProgramCd}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            helperText={''}
                            inputProps={{
                              id: 'rebate_program_code',
                            }}
                          />
                          {/* <label
                            className='m-0 hide-elm'
                            htmlFor='short_rebate_program_code'
                          >
                            <span>label</span>{' '}
                          </label> */}
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='labeler-tooltip'>
                                {String(
                                  rebateProgramCode?.find(
                                    (item) =>
                                      item.rebateProgramCd ===
                                      calculatedURAHeaderData?.rebateProgramCd
                                  )?.shortDescr ?? ''
                                )}
                              </Tooltip>
                            }
                          >
                            <TextField
                              className='mandate-fields frr-display-hidden-label'
                              label={'Rebate Program Code'}
                              id='short_rebate_program_code'
                              disabled={true}
                              value={String(
                                rebateProgramCode?.find(
                                  (item) =>
                                    item.rebateProgramCd ===
                                    calculatedURAHeaderData?.rebateProgramCd
                                )?.shortDescr ?? ''
                              )}
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                id: 'short_rebate_program_code',
                              }}
                              helperText={''}
                            />
                          </OverlayTrigger>
                        </div>

                        <div className='col-4 d-flex'>
                          <TextField
                            className='mandate-fields mr-2'
                            id='manufacturer_id'
                            label={'Manufacturer ID'}
                            disabled={true}
                            value={calculatedURAHeaderData?.mfgId}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            helperText={''}
                            inputProps={{
                              id: 'manufacturer_id',
                            }}
                          />
                          {/* <label className='m-0 hide-elm' htmlFor='mfg_name'>
                            <span>label</span>{' '}
                          </label> */}
                          <OverlayTrigger
                            placement='bottom'
                            overlay={
                              <Tooltip id='labeler-tooltip'>
                                {calculatedURAHeaderData?.mfgName}
                              </Tooltip>
                            }
                          >
                            <TextField
                              className='mandate-fields frr-display-hidden-label'
                              id='mfg_name'
                              label={'Manufacturer Name'}
                              disabled={true}
                              value={calculatedURAHeaderData?.mfgName}
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                id: 'mfg_name',
                              }}
                              helperText={''}
                            />
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className='row mt-3'>
                        <div className='col-2 d-flex'>
                          <TextField
                            className='mandate-fields mr-2'
                            id='target_quarter'
                            label={'Target Quarter'}
                            disabled={true}
                            value={handleQuarterFormate(
                              calculatedURAHeaderData?.targetQtr
                            )}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              id: 'target_quarter',
                            }}
                            helperText={''}
                          />
                        </div>

                        <div className='col-5 d-flex'>
                          <TextField
                            className='mandate-fields mr-2'
                            id='drug_family_name'
                            label={'Drug Family Name'}
                            disabled={true}
                            value={calculatedURAHeaderData?.familyName}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            helperText={''}
                          />
                          {/* <label
                            className='m-0 hide-elm'
                            htmlFor='family_description'
                          >
                            <span>label</span>{' '}
                          </label> */}
                          <TextField
                            className='mandate-fields frr-display-hidden-label'
                            id='family_description'
                            label={'Drug Family Descr'}
                            disabled={true}
                            value={calculatedURAHeaderData?.familyDescr}
                            placeholder=''
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              id: 'family_description',
                            }}
                            helperText={''}
                          />
                        </div>

                        <div className='col-5 d-flex'>
                          {(URASearchFormValues?.planType != 'FD' &&
                            URASearchFormValues?.selectOneOption !=
                              'Manufacturer') ||
                          (URASearchFormValues?.planType != 'ST' &&
                            URASearchFormValues?.selectOneOption !=
                              'Manufacturer') ? (
                            <TextField
                              className='mandate-fields mr-2'
                              id='ndc'
                              label={'NDC'}
                              disabled={true}
                              value={
                                calculatedURAHeaderData?.labelerCode &&
                                calculatedURAHeaderData?.productCode &&
                                calculatedURAHeaderData?.packageSize
                                  ? `${calculatedURAHeaderData?.labelerCode}-${calculatedURAHeaderData?.productCode}-${calculatedURAHeaderData?.packageSize}`
                                  : ''
                              }
                              placeholder=''
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                id: 'ndc',
                              }}
                              helperText={''}
                            />
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </>
        )}
        {(calculatedURAHeaderData?.planTypeCd === 'COMM' ||
          calculatedURAHeaderData?.planTypeCd === 'SUPP') && (
          <React.Fragment>
            <TopGridTable
              fullScreen={fullScreenView}
              setFullScreen={setFullScreenView}
            />
            <CalculatedURATable
              fullScreen={fullScreenView}
              setFullScreen={setFullScreenView}
            />
          </React.Fragment>
        )}
        {(calculatedURAHeaderData?.planTypeCd === 'FD' ||
          calculatedURAHeaderData?.planTypeCd === 'ST') && (
          <BottomGridTable
            fullScreen={fullScreenView}
            setFullScreen={setFullScreenView}
          />
        )}
        <div className='clearfix' />
      </div>
    </div>
  );
};

export default SelectedURA;
